declare var jQuery:any;
export function show_loader( show:boolean ) {
    const loader = jQuery( '[data-global-loader]' );
    if( loader.length > 0 ) {
        if( show ) {
            loader.show(true);
        } else {
            loader.hide(false);
        }
    }
}